import React from "react";
import { connect } from "react-redux";
import { FeatherIcon, getIcon, noAvatar } from "../../Components/Functions";
import { loggedUser } from "./Messanger";

const ChatLeftSide = (props) => {
	const ACCOUNT = props.account;

	if(!ACCOUNT?.username) return <div/>

	return (
		<div className={`chat-side ${props.collapse1 ? "is-mobile-active" : ""}`}>
			<div className="chat-side-header">
				<div className="toolbar ml-auto">
				
					<div className="toolbar-notifications is-hidden-mobile">
						<div className="dropdown is-spaced is-dots is-right dropdown-trigger">
							<div className="is-trigger" aria-haspopup="true">
								<FeatherIcon icon="bell" />
								<span className="new-indicator pulsate" />
							</div>
							<div className="dropdown-menu" role="menu">
								<div className="dropdown-content">
									<div className="heading">
										<div className="heading-left">
											<h6 className="heading-title">Notifications</h6>
										</div>
										<div className="heading-right">
											<a
												className="notification-link"
												href="/admin-profile-notifications.html"
											>
												See all
											</a>
										</div>
									</div>
									<ul className="notification-list">
										<li>
											<a className="notification-item">
												<div className="img-left">
													<img
														className="user-photo"
														alt=""
														src="https://via.placeholder.com/150x150"
														data-demo-src="https://huro.cssninja.io/assets/img/avatars/photos/7.jpg"
													/>
												</div>
												<div className="user-content">
													<p className="user-info">
														<span className="name">Alice C.</span> left a
														comment.
													</p>
													<p className="time">1 hour ago</p>
												</div>
											</a>
										</li>
										<li>
											<a className="notification-item">
												<div className="img-left">
													<img
														className="user-photo"
														alt=""
														src="https://via.placeholder.com/150x150"
														data-demo-src="https://huro.cssninja.io/assets/img/avatars/photos/12.jpg"
													/>
												</div>
												<div className="user-content">
													<p className="user-info">
														<span className="name">Joshua S.</span> uploaded a
														file.
													</p>
													<p className="time">2 hours ago</p>
												</div>
											</a>
										</li>
										<li>
											<a className="notification-item">
												<div className="img-left">
													<img
														className="user-photo"
														alt=""
														src="https://via.placeholder.com/150x150"
														data-demo-src="https://huro.cssninja.io/assets/img/avatars/photos/13.jpg"
													/>
												</div>
												<div className="user-content">
													<p className="user-info">
														<span className="name">Tara S.</span> sent you a
														message.
													</p>
													<p className="time">2 hours ago</p>
												</div>
											</a>
										</li>
										<li>
											<a className="notification-item">
												<div className="img-left">
													<img
														className="user-photo"
														alt=""
														src="https://via.placeholder.com/150x150"
														data-demo-src="https://huro.cssninja.io/assets/img/avatars/photos/25.jpg"
													/>
												</div>
												<div className="user-content">
													<p className="user-info">
														<span className="name">Melany W.</span> left a
														comment.
													</p>
													<p className="time">3 hours ago</p>
												</div>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<a id="hide-chat-side" className="toolbar-link" 
                        dangerouslySetInnerHTML={{ __html: getIcon("chevron-right") }}
                        onClick={() => props.setCollapse1(!props.collapse1)}
                    />
				</div>
			</div>
			<div className="chat-side-content is-single">
				<div className="user-pic">
					<img id="user-details-image" src={ACCOUNT.image || noAvatar()} alt="" />
					<div
                        className={`badge ${
                            props?.is_active ? "bg-success" : "bg-danger"
                        } status-badge`}
                        style={{ 
                            width: 20, height: 20
                        }}
                    />
				</div>
				<h4 id="user-details-name" className="user-name">
					{ACCOUNT?.name}
				</h4>
				<p id="user-details-title" className="user-job-title">
					@{ACCOUNT?.username}
				</p>
                {ACCOUNT?.username && (
                    <>
                        <div className="side-actions">
                            <a
                                className="button h-button is-rounded mr-2"
                                href={"tel:" + ACCOUNT?.phone}
                            >
                                <span className="icon is-small">
                                    <i aria-hidden="true" className="fas fa-phone" />
                                </span>
                                <span>Audio Call</span>
                            </a>
                            <a
                                className="button h-button is-rounded"
                                href={
                                    "https://us04web.zoom.us/j/72268407263?pwd=MUt5MkR5azBkQjJaelY5VnZFQ2Rwdz09"
                                }
                            >
                                <span className="icon is-small">
                                    <i aria-hidden="true" className="fas fa-video" />
                                </span>
                                {loggedUser?.role === "SPECIALIST" ? (
                                    <span>Start Zoom</span>
                                ) : (
                                    <span>Join on Zoom</span>
                                )}
                            </a>
                        </div>
                        <div className="detail-photos">
                            <div
                                className="detail-photo-title"
                                dangerouslySetInnerHTML={{
                                    __html: getIcon("image") + " Shared photos",
                                }}
                            />
                            <div className="detail-photo-grid">
                                {(ACCOUNT?.sharedMedia?.length > 0 && (
                                    <>
                                        {ACCOUNT?.sharedMedia?.map((media) => {
                                            return (
                                                <img
                                                    src="https://via.placeholder.com/1600x900"
                                                    data-demo-src="https://huro.cssninja.io/assets/img/photo/demo/demo-apps/1.jpg"
                                                    alt=""
                                                />
                                            );
                                        })}
                                        <a className="view-more">View More</a>
                                    </>
                                )) || (
                                    <div style={{ position: "absolute", left: "10%", right: "10%" }}>
                                        <img
                                            className="light-image"
											src={require("../../assets/img/illustrations/placeholders/search-4.svg").default}
                                            alt=""
                                        />
                                        <div className="text">
                                            <h3>No media found</h3>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {loggedUser?.role === "SPECIALIST" && (
                            <div className="recommendation-buttons">
                            <button className="button w-100 h-button is-primary is-elevated">
                                <span class="icon" dangerouslySetInnerHTML={{ __html: getIcon("plus") }}>
                                </span>
                                <span>Recommend Drugs</span>
                            </button>
                            <button className="button h-button w-100 is-danger mt-2 is-elevated">
                                <span class="icon" dangerouslySetInnerHTML={{ __html: getIcon("heart") }}>
                                </span>
                                <span>Recommend Hospital</span>
                            </button>
                            </div>
                        )}
                    </>
                )}


			</div>
		</div>
	);
};

const mapStateToProps = ({ chats, chathistory }) => {
    const list = chats?.chatlist;
	return { 
            account: chathistory?.user || {}, 
            is_active: list ? list?.find(e => e.username === chathistory?.user?.username)?.is_active : false
        };
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatLeftSide);
